import { useFormikContext } from "formik";
import get from "lodash/get";

export const useFieldValueAndValidation = (fieldName?: string) => {
    const { values, errors, touched } = useFormikContext<any>();

    let value = "";
    let error;
    let hasTouched;

    if (fieldName) {
        value = get(values, fieldName);
        error = get(errors, fieldName);
        hasTouched = get(touched, fieldName);
    }

    return {
        value,
        error,
        hasTouched,
    };
};

export * from "./validationMessages";
